import type { $Fetch } from 'ofetch';
import type { VendaPagamento } from '@/domain/model/VendaPagamento';
import type { Page } from '@/domain/model/Page';
import type { AdminPagamentoGateway, ListAdminPagamentosParams } from '@/application/port/out/AdminPagamentoGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/pagamentos';

export class HttpAdminPagamentoGateway implements AdminPagamentoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: ListAdminPagamentosParams): Promise<Page<VendaPagamento>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.gatewayCodigo) params['gatewayCodigo'] = p.gatewayCodigo;
    if (p.parcelaId) params['parcelaId'] = p.parcelaId;
    if (p.vendaId) params['vendaId'] = p.vendaId;
    if (p.alunoId) params['alunoId'] = p.alunoId;
    if (p.vendedorUserId) params['vendedorUserId'] = p.vendedorUserId;
    if (p.registradoDe) params['registradoDe'] = p.registradoDe;
    if (p.registradoAte) params['registradoAte'] = p.registradoAte;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<VendaPagamento>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }
}
